(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amani-localization-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__amaniLocalizationHydrationReady) return;
    window.__amaniLocalizationHydrationReady = true;

    function hydrateCountrySelect(container) {
      var template = document.getElementById('AmaniLocalizationCountryOptions');
      if (!template || !container) return;

      container.querySelectorAll('[data-amani-localization-country-select]').forEach(function (select) {
        if (select.dataset.hydrated === 'true') return;

        var current = select.dataset.currentCountry || select.value;
        select.innerHTML = template.innerHTML;
        select.value = current;
        select.dataset.hydrated = 'true';
        select.removeAttribute('aria-busy');
      });
    }

    document.addEventListener('click', function (event) {
      var summary = event.target.closest('.amani-localization__summary');
      if (!summary) return;
      hydrateCountrySelect(summary.closest('.amani-localization'));
    });

    document.addEventListener('focusin', function (event) {
      if (!event.target.matches('[data-amani-localization-country-select]')) return;
      hydrateCountrySelect(event.target.closest('.amani-localization'));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
